import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';

import { UserRoles } from '../interfaces/user-roles.enum';
import { CurrentUserService } from './services';

export const administratorCanActivate: CanActivateFn = () => {
  const currentUser = inject(CurrentUserService);
  const router = inject(Router);

  return currentUser.profile?.role === UserRoles.Administrator ? true : router.parseUrl('/');
};
